
export const forceColorsById = (id,darkmode) =>  {
  var elem;
  const background = (darkmode != "" && darkmode != "light") ? "black" : "white"
  const color = (darkmode != "" && darkmode != "light") ? "white" : "black"

  if (elem = document.getElementById(id)) {
    elem.style.backgroundColor = background;
    elem.style.color = color
  }
}